import styled from "styled-components";

const HeaderWrapper = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export default HeaderWrapper;
